/* esm.sh - d3-transition@3.0.1/src/transition/selection */
export * from "/*d3-transition@3.0.1/esnext/src/transition/selection.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/selection.mjs";
